import { useState } from "react";
import Button from "../../common/ui/Button";
import PasswordInput from "../../common/ui/Inputs/PasswordInput";
import { useDispatch } from "react-redux";
import changePasswordSchema from "../../../validation/changePasswordSchema";
import { encryptData } from "../../../utils/encryptDecrypt";
import { authActions } from "../../../_store";
import { showToastNotification } from "../../common/ui/NotificationModal/ToastNotication";
import { history } from "../../../_helpers";

function AdminChangePassword() {
  const dispatch = useDispatch();
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [submit, setSubmit] = useState(false);
  const [errorMessage, setErrorMessage] = useState({});
  const [password, setPassword] = useState({
    oldPassword: "",
    password: "",
  });

  const restrictCharacters = (e, restrictedChars = ["'", "`"]) => {
    if (restrictedChars.includes(e.key)) {
      e.preventDefault(); // Prevent the restricted character from being entered
    }
  };

  const togglePasswordVisibility = (type) => {
    type === "password"
      ? setShowPassword((prev) => !prev)
      : setShowConfirmPassword((prev) => !prev);
  };

  const handleInputChange = (e) => {
    const { name, value } = e?.target;
    setPassword((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };
  const handleReset = () => {
    setErrorMessage({});
    setPassword({
      oldPassword: "",
      password: "",
    });
  };
  const handleSubmit = async (event) => {
    debugger;
    event.preventDefault();

    setErrorMessage({});
    setSubmit(true);
    const { error } = changePasswordSchema(password);
    if (error?.details) {
      setSubmit(false);
      error?.details?.map((e) => {
        const { path } = e;
        setErrorMessage((prev) => ({
          ...prev,
          [path[0]]: e?.message,
        }));
      });
      return;
    }

    let _oldPassword = encryptData(password?.oldPassword);
    let _password = encryptData(password?.password);

    dispatch(
      authActions.changePassword({
        oldPassword: _oldPassword,
        password: _password,
      })
    )
      .then((result) => {
        setSubmit(false);
        if (result?.payload?.status === 1) {
          showToastNotification(result?.payload?.message, "success");
          setSubmit(false);
          history?.navigate("dashboard");
        } else {
          showToastNotification(result?.error?.message, "error");
        }
      })
      .catch((err) => {
        showToastNotification("Failed to change password", "error");
        setSubmit(false);
      });

    setSubmit(false);
    handleReset();
  };

  return (
    <div className="container-fluid px-3">
      <div
        className="card b-r-all p-4 border border-dark-grey mt-3 mx-auto"
        style={{ maxWidth: "600px" }}
      >
        <div className="card-body">
          <h2 className="form_title_uppercase text-color text-center mb-3">
            CHANGE PASSWORD
          </h2>
          <form onSubmit={handleSubmit}>
            <div className="mb-4">
              <label for="username" className="form-label">
                Old Password<span className="text-danger">*</span>
              </label>

              <PasswordInput
                name="oldPassword"
                id="oldPassword"
                onKeyDown={(e) => restrictCharacters(e)}
                value={password?.oldPassword}
                handleChange={handleInputChange}
                placeholder="Old Password"
                required={true}
                errorMessage={errorMessage}
                showPassword={showPassword}
                togglePasswordVisibility={() =>
                  togglePasswordVisibility("password")
                }
                autoComplete="new-password"
                maxlength={25}
              />
            </div>
            <div className="mb-4">
              <label for="username" className="form-label">
                New Password<span className="text-danger">*</span>
              </label>

              <PasswordInput
                name="password"
                id="password"
                onKeyDown={(e) => restrictCharacters(e)}
                value={password?.password}
                handleChange={handleInputChange}
                placeholder="New Password"
                required={true}
                errorMessage={errorMessage}
                showPassword={showConfirmPassword}
                togglePasswordVisibility={() =>
                  togglePasswordVisibility("confirm")
                }
                autoComplete="new-password"
                maxlength={25}
              />
            </div>

            <div className="d-flex justify-content-center align-items-center gap-2">
              <Button
                status="primary"
                type="submit"
                label="Submit"
                disabled={submit}
              />
              <Button
                status="reset"
                label="Reset"
                type="reset"
                onClick={handleReset}
                // disabled={true}
              />
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default AdminChangePassword;
